import React from 'react';
import HeroSection2 from '../components/HeroSection2';
import TryNowSection from '../components/TryNowSection';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-primary to-secondary">
      <main>
        {/* Hero and Try Now sections side by side */}
        <div className="flex flex-col lg:flex-row min-h-screen">
          {/* Left side - Hero Section */}
          <div className="lg:w-1/2 lg:flex lg:items-center">
            <HeroSection2 
              title="Where Teams Become Companions"
              subtitle="Build beautiful team pages that showcase your society of talent. From Old French 'compagnie' - a body of soldiers working together. Perfect for startups, agencies, and growing organizations."
              strapline="The fastest way to showcase your bread-sharing companions"
              bgColor="from-primary to-secondary"
              textColor="text-white"
              logoLinkColor="text-white"
              button1Text="Start Now"
              button2Text=""
            />
          </div>

          {/* Right side - Try Now Section */}
          <div className="lg:w-1/2 lg:flex lg:items-center">
            <TryNowSection />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
